<template>

    <button v-if="as === 'button'"
        class="transition text-white pl-5 pr-6 py-1 text-base text-left relative border-transparent border-l-4"
        style="width: available;"
        :class="{
            'border-white': active,
            'hover:border-white': ! active,
        }">

        <slot></slot>

    </button>

    <Link v-else
        :href="href"
        class="transition text-white pl-5 pr-6 py-1 text-base relative border-transparent border-l-4"
        :class="{
            'border-white': active,
            'hover:border-white': ! active,
        }">

        <slot></slot>

    </Link>

</template>

<script>
import { defineComponent } from 'vue'
import { Link } from '@inertiajs/inertia-vue3';

export default defineComponent({

    props: {
        href: String,
        as: String,
    },

    components: {
        Link,
    },

    computed: {

        active() {

            return location.href.indexOf( this.href ) === 0;

        }

    }

});
</script>
